import Main from "../views/main";

// 管理员路由
import Administrators from "./administrators";
import aiFriendManageRoute from "./aiFriendManage";
import aiFriendStatRoute from "./aiFriendStat";
// AI管理
import AiManageRouter from "./aiManage";
// 系统管理
import SystemManageRouter from "./systemManage";
// 不需要权限控制的路由
const authRouter = [{
    path: "/home",
    component: Main,
    title: "首页",
    icon: "el-icon-s-home",
    level: 0,
    children: [{
      path: "/home",
      component: () => import("@/views/home/index"),
      name: "home",
      title: "首页",
      meta: {
        title: "首页"
      },
    }, ],
  },
  Administrators,
  AiManageRouter,
  aiFriendManageRoute,
  aiFriendStatRoute,
  SystemManageRouter,
  {
    path: "/roleManagement",
    component: Main,
    title: "权限管理",
    icon: "el-icon-s-custom",
    level: 0,
    children: [{
      path: "/roleManagement",
      component: () => import("@/views/role/index"),
      name: "roleManagement",
      title: "权限管理",
      meta: {
        title: "权限管理"
      },
    }, ],
  },
];
export default authRouter;